// import { useState } from "react";

// export default function PromotionsPage() {
//   const [promotions] = useState([
//     {
//       id: "PROMO-001",
//       name: "New Year Sale",
//       type: "Percentage",
//       discount: "20%",
//       products: 15,
//       status: "ACTIVE",
//       start: "2025-01-01",
//       end: "2025-01-10",
//       orders: 124,
//     },
//     {
//       id: "PROMO-002",
//       name: "Clearance Deal",
//       type: "Fixed Amount",
//       discount: "ETB 300",
//       products: 8,
//       status: "SCHEDULED",
//       start: "2025-01-15",
//       end: "2025-01-20",
//       orders: 0,
//     },
//   ]);

//   const renderStatus = (status) => {
//     const map = {
//       ACTIVE: ["Active", "success"],
//       SCHEDULED: ["Scheduled", "info"],
//       EXPIRED: ["Expired", "secondary"],
//       PAUSED: ["Paused", "warning"],
//     };

//     return (
//       <span
//         className={`badge bg-${map[status][1]}-subtle text-${map[status][1]}`}
//       >
//         {map[status][0]}
//       </span>
//     );
//   };

//   return (
//     <div className="p-4">
//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <div className="d-flex align-items-center gap-2">
//           <span style={{ fontSize: 22 }}>🎯</span>
//           <h4 className="mb-0 fw-semibold">Promotions</h4>
//         </div>

//         <button className="btn btn-primary">+ Create promotion</button>
//       </div>

//       {/* Promotion Types */}
//       <div className="row g-3 mb-4">
//         {[
//           { title: "Percentage Discount", icon: "📉" },
//           { title: "Fixed Amount", icon: "💰" },
//           { title: "Buy X Get Y", icon: "🎁" },
//           { title: "Free Shipping", icon: "🚚" },
//         ].map((type) => (
//           <div className="col-md-3" key={type.title}>
//             <div className="border rounded p-3 h-100">
//               <div className="d-flex align-items-center gap-2">
//                 <span>{type.icon}</span>
//                 <strong>{type.title}</strong>
//               </div>
//               <p className="text-muted mt-2 mb-0">
//                 Create and manage this promotion type
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Promotions Table */}
//       <div className="table-responsive border rounded">
//         <table className="table mb-0 align-middle">
//           <thead className="table-light">
//             <tr>
//               <th>Name</th>
//               <th>Type</th>
//               <th>Discount</th>
//               <th>Products</th>
//               <th>Status</th>
//               <th>Start</th>
//               <th>End</th>
//               <th>Orders</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {promotions.map((promo) => (
//               <tr key={promo.id}>
//                 <td className="fw-semibold">{promo.name}</td>
//                 <td>{promo.type}</td>
//                 <td>{promo.discount}</td>
//                 <td>{promo.products}</td>
//                 <td>{renderStatus(promo.status)}</td>
//                 <td>{promo.start}</td>
//                 <td>{promo.end}</td>
//                 <td>{promo.orders}</td>

//                 <td>
//                   <div className="d-flex gap-2">
//                     <button className="btn btn-sm btn-outline-secondary">
//                       Edit
//                     </button>

//                     {promo.status === "ACTIVE" && (
//                       <button className="btn btn-sm btn-outline-warning">
//                         Pause
//                       </button>
//                     )}

//                     <button className="btn btn-sm btn-outline-danger">
//                       End
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

import { useState } from "react";
import DiscountForm from "./DiscountForm";
import AdsForm from "./AdsForm";
export default function PromotionsPage() {
  const [activeTab, setActiveTab] = useState("discount");

  return (
    <div className="p-4">
      {/* Header */}
      <h4 className="fw-semibold mb-4"> Promotions & Ads</h4>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "discount" ? "active" : ""}`}
            onClick={() => setActiveTab("discount")}
          >
            Discounts
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "ads" ? "active" : ""}`}
            onClick={() => setActiveTab("ads")}
          >
            Ads
          </button>
        </li>
      </ul>

      {activeTab === "discount" && <DiscountForm />}
      {activeTab === "ads" && <AdsForm />}
    </div>
  );
}
